import { DeleteOutlined, EditOutlined, EyeOutlined, PlusOutlined, SaveOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Space, Table, Tabs, Upload, UploadFile, UploadProps } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { urlAdmin } from '../../constants';
import { validateMessages } from '../../helpers/common';
import { DanhGiaXepLoai } from '../../models/nhanvien/QuaTrinhLamViec';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { luuDanhGiaXepLoai, xoaDanhGiaXepLoai } from '../../services/nhanvien';
import KetQuaDanhGiaSelectBox from '../utils/KetQuaDanhGiaSelectBox';

const { TextArea } = Input;
const DanhGiaXepLoaiBox = ({ listData, idNhanVien, isThemMoi, onSubmit }: { listData?: Array<DanhGiaXepLoai>, idNhanVien?: number, isThemMoi?: boolean, onSubmit: () => void }) => {
    var dataSource = (listData || []).map((item: any, index) => { item.key = index; return item; });
    const [loading, setLoading] = useState(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);

    const [selectedKT, setSelectedKT] = useState<DanhGiaXepLoai>(new DanhGiaXepLoai);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    useEffect(() => {
        var fileHienTai: any = (selectedKT?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
                //url: item.duongDan.replace("View\\public", urlAdmin).replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai)
    }, [selectedKT]);

    const props: UploadProps = {
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    };

    const [form] = Form.useForm();
    const setFormDetailModal = (value: DanhGiaXepLoai | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "idNhanVien": idNhanVien,
            "nam": value?.nam || "",
            "idKetQuaDanhGia": value?.idKetQuaDanhGia || null,
            "tenKetQuaDanhGia": value?.tenKetQuaDanhGia || "",
            "ghiChu": value?.ghiChu || "",
        });
        setShowModalChiTiet(true);
    }

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await luuDanhGiaXepLoai(values, fileList, idsTaiLieuXoa);
            setShowModalChiTiet(false);
            setSelectedKT(new DanhGiaXepLoai);
            toast.success('Lưu đánh giá xếp loại thành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        setLoading(false);
        onSubmit();
    };

    const onDelete = async () => {
        try {
            setLoading(true);
            await xoaDanhGiaXepLoai(idXoa);
            toast.success('Xoá đánh giá xếp loại thành công!');
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setLoading(false);
        onSubmit();
    }
    return (
        <div className="card-outline">
            {idXoa > 0 && <ModalTextForm show={idXoa > 0}
                title="Xoá đánh giá xếp loại"
                handleClose={() => setIdXoa(0)}
                handleSave={onDelete}>
                Xác nhận xóa đánh giá xếp loại đang chọn
            </ModalTextForm>}
            {showModalChiTiet && <ModalTextForm title="Quản lý đánh giá xếp loại"
                hideFooter
                show={showModalChiTiet}
                handleClose={() => {
                    setShowModalChiTiet(false);
                    setSelectedKT(new DanhGiaXepLoai);
                }}
            >
                {isThemMoi ? <Form
                    layout="vertical"
                    validateMessages={validateMessages}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item hidden name="id"><Input /></Form.Item>
                    <Form.Item hidden name="idNhanVien"><Input /></Form.Item>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label="Năm đánh giá"
                                name="nam"
                                rules={[{ required: true }]}
                            >
                                <Input type="number"/>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="idKetQuaDanhGia" label="Kết quả đánh giá" rules={[{ required: true }]}>
                                <KetQuaDanhGiaSelectBox onChange={() => { }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span="24">
                            <Form.Item name="ghiChu" label="Ghi chú">
                                <TextArea rows={4} placeholder="Ghi chú" />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Upload {...props}>
                                <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                            </Upload>
                        </Col>
                    </Row>
                    <Form.Item>
                        <Button type="primary" className="float-right mt-2" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                            Lưu
                        </Button>
                    </Form.Item>
                </Form>
                    :
                    <>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Năm đánh giá</div>
                                    <label>{selectedKT?.nam}</label>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Kết quả đánh giá</div>
                                    <label>{selectedKT?.tenKetQuaDanhGia}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="mb-1">
                                    <div>Ghi chú</div>
                                    <label>{selectedKT?.ghiChu}</label>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="24">
                                <div className="mb-1">
                                    <div>File đính kèm</div>
                                    <Upload {...props} disabled={true}>
                                    </Upload>
                                </div>
                            </Col>
                        </Row>
                    </>}
            </ModalTextForm>}
            <Tabs tabBarExtraContent={isThemMoi ?
                <Button
                    className="hrm-btn hrm-btn-warning"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
                : null} defaultActiveKey="1" items={[
                    {
                        key: '1',
                        label: 'Đánh giá xếp loại',
                        children:
                            <div className="card">
                                <Table
                                    locale={{ emptyText: "Không có dữ liệu" }}
                                    dataSource={dataSource}
                                    pagination={false}
                                    rowClassName={(record, index) => {
                                        return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                    }}
                                ><Column
                                        title="STT"
                                        key="STT"
                                        className="text-center"
                                        render={(value, record, index) =>
                                        (
                                            <>
                                                {index + 1}
                                            </>
                                        )
                                        }
                                    />
                                    <Column
                                        title="Năm đánh giá"
                                        className="text-center"
                                        key="năm"
                                        dataIndex="nam"
                                    />
                                    <Column title="Kết quả đánh giá" key="tenKetQuaDanhGia" dataIndex="tenKetQuaDanhGia" />
                                    {isThemMoi ?
                                        <Column width="10%" title="" key="action"
                                            render={(value: DanhGiaXepLoai, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Sửa"
                                                        icon=<EditOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedKT(value) }}
                                                    >
                                                        Sửa
                                                    </Button>
                                                    <Button type="primary" danger size={"small"} loading={loading} title="Xóa"
                                                        onClick={() => { setIdXoa(value.id) }}
                                                        icon=<DeleteOutlined rev="" />
                                                    >
                                                        Xóa
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        /> :
                                        <Column width="10%" title="" key="action"
                                            render={(value: DanhGiaXepLoai, record, index) =>
                                            (
                                                <Space>
                                                    <Button type="primary" size={"small"} loading={loading} title="Xem"
                                                        icon=<EyeOutlined rev="" />
                                                        onClick={() => { setFormDetailModal(value); setSelectedKT(value) }}
                                                    >
                                                        Xem
                                                    </Button>
                                                </Space>
                                            )
                                            }
                                        />
                                    }
                                </Table>
                            </div>
                    },
                ]}>
            </Tabs>
        </div>
    );
};

export default DanhGiaXepLoaiBox;
